import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M13 8H11V16H13V8Z" xmlns="http://www.w3.org/2000/svg" />,
  "LineS"
);
